import makeApi from "../../libs/axios/api";
import { StateList, type Country } from "../../types/country";
const apiPromise = makeApi();

const ADD_PATH = "/country";

const getCountry = async (): Promise<Country[]> => {
  const api = await apiPromise;
  return api.get(ADD_PATH).then((response) => {
    return response.data as Country[];
  });
};

export const getStateList = async (
  countryCode: String
): Promise<StateList[]> => {
  const PATH = `/country/${countryCode}/state`;

  const api = await apiPromise;
  return api.get(PATH).then((response) => {
    return response.data as StateList[];
  });
};
export default getCountry;
